<template>
  <a
    v-if="size != 'hidden'"
    href="https://www.cloudns.net/ads/id/987/"
    rel="sponsored noopener"
    :class="[sizeClasses, 'block relative overflow-hidden rounded-md shadow-md border border-black/10']">
    <img
      :src="`/img/${size[0].toString().split('').reverse().join('')}x${size[1].toString().split('').reverse().join('')}.png`"
      alt="ClouDNS - 50% off DDoS protected DNS"
      class="w-full h-full object-cover object-center">
  </a>
</template>

<script setup lang="ts">
import { PropType, computed } from 'vue';
import {
  AdSize, Billboard, MediumRectangle,
} from '@/common/adSizes';

const props = defineProps({
  sizes: {
    type: Array as PropType<Array<AdSize>>,
    required: true,
  },
});

const availableSizes = [
  Billboard,
  MediumRectangle,
];

const size = computed(() => availableSizes.find((s) => props.sizes.includes(s)) ?? 'hidden');
const sizeClasses = computed(() => {
  switch (size.value) {
    case Billboard:
      return 'w-[970px] h-[250px]';
    case MediumRectangle:
      return 'w-[300px] h-[250px]';
    default:
      return 'hidden';
  }
});
</script>
